import React, { useState, useEffect } from 'react';
import { RootState } from '../Redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { setAuth } from '../Redux/authSlice';
import { translations } from '../utils/translations';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Card, Breadcrumb, Pagination } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import "./expense.css";
interface Expense {
    id: number;
    Expenses_type: string;
    Cost: string;
    date_paid_expenses: string;
}

export default function ExpenseComponent() {
    const [expenses, setExpenses] = useState<Expense[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [userRole, setUserRole] = useState<string | null>(null);
    const [selectedExpense, setSelectedExpense] = useState<Expense | null>(null);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);
    const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
    const [editType, setEditType] = useState<string>('');
    const [editCost, setEditCost] = useState<string>('');
    const [editDatePaid, setEditDatePaid] = useState<string>('');
    const [newExpenseType, setNewExpenseType] = useState<string>('');
    const [newCost, setNewCost] = useState<string>('');
    const [newDatePaid, setNewDatePaid] = useState<string>(new Date().toISOString().split('T')[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [searchTerm, setSearchTerm] = useState<string>(''); // State for search term

    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth.value);
    const language = useSelector((state: RootState) => state.language.language);
    const t = translations[language as keyof typeof translations];

    const getCookie = (name: string) => {
        const cookieName = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        return '';
    };

    const fetchData = async () => {
        try {
            const token = getCookie('token');
            if (!token) {
                dispatch(setAuth(false));
                return;
            }
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const userResponse = await axios.get('https://api.sominnovations.xyz/users/user', {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            setUserRole(userResponse.data.user.role);
            dispatch(setAuth(true));
        } catch (e) {
            dispatch(setAuth(false));
        }
    };

    const fetchExpenses = async (page: number) => {
        setLoading(true);
        try {
            const response = await axios.get(`https://api.sominnovations.xyz/Branches/expenses/?page=${page}&search=${searchTerm}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            setExpenses(response.data.results);
            setTotalPages(Math.ceil(response.data.count / 20)); // Assuming 20 items per page
        } catch (error) {
            console.error('Error fetching expenses:', error);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [dispatch]);

    useEffect(() => {
        if (auth) {
            fetchExpenses(currentPage);
        }
    }, [auth, currentPage, searchTerm]); // Add searchTerm to dependencies

    const handleEdit = (expense: Expense) => {
        setSelectedExpense(expense);
        setEditType(expense.Expenses_type);
        setEditCost(expense.Cost);
        setEditDatePaid(expense.date_paid_expenses);
        setShowEditModal(true);
    };

    const handleSaveEdit = async () => {
        if (selectedExpense) {
            try {
                await axios.patch(`https://api.sominnovations.xyz/Branches/expenses/${selectedExpense.id}/`, {
                    Expenses_type: editType,
                    Cost: editCost,
                    date_paid_expenses: editDatePaid,
                });
                setExpenses(expenses.map(expense =>
                    expense.id === selectedExpense.id
                        ? { ...expense, Expenses_type: editType, Cost: editCost, date_paid_expenses: editDatePaid }
                        : expense
                ));
                setShowEditModal(false);
            } catch (error) {
                console.error('Error updating expense:', error);
            }
        }
    };

    const handleCreateExpense = async () => {
        try {
            const response = await axios.post('https://api.sominnovations.xyz/Branches/expenses/', {
                Expenses_type: newExpenseType,
                Cost: newCost,
                date_paid_expenses: newDatePaid,
            });
            setExpenses([...expenses, response.data]);
            setShowCreateModal(false);
            setNewExpenseType('');
            setNewCost('');
            setNewDatePaid('');
        } catch (error) {
            console.error('Error creating expense:', error);
        }
    };

    const handleView = (id: number) => {
        console.log('View expense with ID:', id);
    };

    const handleDelete = async (id: number) => {
        if (window.confirm("Are you sure you want to delete expense?")) {
            try {
                await axios.delete(`https://api.sominnovations.xyz/Branches/expenses/${id}/`);
                setExpenses(expenses.filter(expense => expense.id !== id));
                console.log('Deleted expense with ID:', id);
            } catch (error) {
                console.error('Error deleting expense:', error);
            }
        }
    };

    return (
        <div className="container mt-1 expenses-container">
            <Card className="mb-4">
                <Card.Header style={{ backgroundColor: '#5271ff', color: '#fff' }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h4>{t.expenses}</h4>
                        <Breadcrumb>
                            <Breadcrumb.Item href="dashboard"><p style={{ color: "white" }}>{t.dashboard}</p></Breadcrumb.Item>
                            <Breadcrumb.Item active>{t.expenses}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Button variant="warning" onClick={() => setShowCreateModal(true)}>
                        + {t.addExpense}
                    </Button>
                </Card.Body>
            </Card>

            <div className="mb-4">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search Expenses..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)} // Update search term state
                />
            </div>

            {loading ? (
                <div>Loading...</div>
            ) : (
                <>
                    <table className="table table-striped">
                        <thead className="table-dark">
                            <tr>
                                <th>#</th>
                                <th>{t.expenseType}</th>
                                <th>{t.expenseCost}</th>
                                <th>{t.datePaid}</th>
                                <th>{t.actions}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {expenses.map((expense, index) => (
                                <tr key={expense.id}>
                                    <td>{index + 1 + (currentPage - 1) * 20}</td>
                                    <td>{expense.Expenses_type}</td>
                                    <td>{expense.Cost}</td>
                                    <td>{expense.date_paid_expenses}</td>
                                    <td>
                                        {/* <button
                                            className="btn btn-info btn-sm me-2"
                                            onClick={() => handleView(expense.id)}
                                        >
                                            <FontAwesomeIcon icon={faEye} />
                                            View
                                        </button> */}
                                        <button
                                            className="btn btn-warning btn-sm me-2"
                                            onClick={() => handleEdit(expense)}
                                        >
                                            <FontAwesomeIcon icon={faEdit} />
                                            Edit
                                        </button>
                                        {userRole !== 'accountant' && (
                                            <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => handleDelete(expense.id)}
                                            >
                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                Delete
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <Pagination>
                        <Pagination.Prev
                            onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                        />
                        {Array.from({ length: totalPages }, (_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => setCurrentPage(index + 1)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next
                            onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        />
                    </Pagination>
                </>
            )}

            {/* Edit Modal */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Expense</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="form-group">
                            <label>Expense Type</label>
                            <input
                                type="text"
                                className="form-control"
                                value={editType}
                                onChange={(e) => setEditType(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Cost</label>
                            <input
                                type="number"
                                className="form-control"
                                value={editCost}
                                onChange={(e) => setEditCost(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Date Paid</label>
                            <input
                                type="date"
                                className="form-control"
                                value={editDatePaid}
                                onChange={(e) => setEditDatePaid(e.target.value)}
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSaveEdit}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Create Modal */}
            <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Create New Expense</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="form-group">
                            <label>Expense Type</label>
                            <input
                                type="text"
                                className="form-control"
                                value={newExpenseType}
                                onChange={(e) => setNewExpenseType(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Cost</label>
                            <input
                                type="number"
                                className="form-control"
                                value={newCost}
                                onChange={(e) => setNewCost(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Date Paid</label>
                            <input
                                type="date"
                                className="form-control"
                                value={newDatePaid}
                                onChange={(e) => setNewDatePaid(e.target.value)}
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleCreateExpense}>
                        Create Expense
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
